/** "3 unread notifications", or null when there are none — each caller words that case its own way. */
export const unreadNotificationsLabel = (count: number): string | null =>
  count > 0 ? `${count} unread notification${count === 1 ? '' : 's'}` : null;
